<div class="livechatStatusText">{{ livechatStatus }}{{ sessionId ? '_' + sessionId : '' }}</div>
